import React, { forwardRef } from "react";

import styles from "./footerWrapper.scss";

const FooterWrapper = forwardRef(({ renderTopBar, children }, ref) => {
  return (
    <div className={styles["wrapper"]} ref={ref}>
      {renderTopBar && renderTopBar()}
      <div className={styles["main-div"]}>{children}</div>
    </div>
  );
});

export default FooterWrapper;
